// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"6bb985d9","745":"5d566e91","893":"157f68dd","936":"57b65aa0","969":"04a1f90c"}[chunkId] + ".chunk.js";
};